import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatherIconNames } from 'feather-icons';
import { FeatherPipe } from '../../../../../core/pipes/feather.pipe';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { TooltipDirective } from '../../../../../shared/directives';
import { AuthenticationService } from '../../../../../core/services/authentication/authentication.service';
import { ROLE_VTEX_ORDERS_WRITE } from '../../../../../core/models/user/user-info.model';
import {
  AlertCode,
  DEFAULT_REPROCESS_INFO,
  OrderAlert,
  OrderReprocessInfo,
} from '../../../../../core/services/order-timeline/order-timeline-event.model';

@Component({
  selector: 'app-integration-alerts',
  standalone: true,
  imports: [CommonModule, FeatherPipe, ButtonComponent, TooltipDirective],
  templateUrl: './integration-alerts.component.html',
  styleUrl: './integration-alerts.component.scss',
})
export class IntegrationAlertsComponent {
  @Input({ required: true }) alerts: OrderAlert[] = [];
  @Input() reprocess: OrderReprocessInfo = DEFAULT_REPROCESS_INFO;
  @Output() reprocessInvoice = new EventEmitter<void>();

  private readonly authService = inject(AuthenticationService);

  get isAllowedToReprocess(): boolean {
    return this.authService.hasRole(ROLE_VTEX_ORDERS_WRITE);
  }

  iconFor(severity: OrderAlert['severity']): FeatherIconNames {
    return severity === 'error' ? 'x-circle' : severity === 'warning' ? 'alert-triangle' : 'info';
  }

  reprocessIcon(info: OrderReprocessInfo): 'refresh-cw' | 'lock' {
    return info.allowed ? 'refresh-cw' : 'lock';
  }

  reprocessTooltip(info: OrderReprocessInfo): string {
    switch (info.lockReason) {
      case 'active_workflow':
        return 'Já existe um workflow ativo para este pedido.';
      case null:
        return 'Reprocessar pedido';
      default:
        return 'Este pedido não atende aos critérios para reprocessamento.';
    }
  }

  titleFor(code: AlertCode): string {
    switch (code) {
      case 'INVOICE_EMITTED':
        return 'Nota fiscal';
      case 'INVOICE_PENDING':
        return 'Nota fiscal pendente';
      case 'INCON_PAGTO':
        return 'Inconsistência de pagamento';
      case 'INCON_TERRAIN':
        return 'Inconsistência Terra/In';
    }
  }

  onReprocessClick(): void {
    this.reprocessInvoice.emit();
  }
}
